import { render, staticRenderFns } from "./Tcm.vue?vue&type=template&id=c910954a&scoped=true"
import script from "./Tcm.vue?vue&type=script&lang=js"
export * from "./Tcm.vue?vue&type=script&lang=js"
import style0 from "./Tcm.vue?vue&type=style&index=0&id=c910954a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c910954a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c910954a')) {
      api.createRecord('c910954a', component.options)
    } else {
      api.reload('c910954a', component.options)
    }
    module.hot.accept("./Tcm.vue?vue&type=template&id=c910954a&scoped=true", function () {
      api.rerender('c910954a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TCMRx/CPD/Tcm.vue"
export default component.exports